import React, {  useEffect } from 'react';
import { Table, Input, Button } from 'antd';
import "./Table.css"
import moment from 'moment';
import Tippy from '@tippyjs/react';
import { EditOutlined } from '@ant-design/icons';
import { BiTrash } from 'react-icons/bi';

function DataTable({ data, onEdit, onDelete }: any) {
    const columns: any= [
        { 
          title: '#', 
          dataIndex: 'index', 
          key: 'index',
          render: (text: any, record: any, index: number) => index + 1,
        },
        {
          title: 'Name', 
          dataIndex: 'name', 
          key: 'name',
        },
        {
          title: 'Actions',
          key: 'actions',
          render: (text: string, record: any) => (
            <div className="row">
                <Button 
                type="primary" 
                icon={<EditOutlined />}
                onClick={() => onEdit(record)}
                className="edit-button"
                style={{backgroundColor: '#4F5052', marginRight: '10px'}}
              >
              </Button>
              <Button 
              type="primary" 
              icon={<BiTrash />}
              onClick={() => onDelete(record)}
              className="edit-button"
              style={{backgroundColor: '#D32A2A'}}
            >
            </Button>
            </div>
          ),
        }
      ];
  
      

    return (
        <Table
            columns={columns}
            // expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
            dataSource={data.map((item: any, index: any) => ({ ...item, index: index + 1 }))}
      />
    );
}

export default DataTable;